import { $e } from '@/utils/Translate.js';

export class CONSTANT_USER {
  static user_type = {
    0: $e("Supprimé"),
    1: $e("Invité"),
    2: $e("Opérateur visu"),
    3: $e("Opérateur"),
    4: $e("Chef d'équipe"),
    5: $e("Administrateur"),
    6: $e("Administrateur (FE)"),
  }

  static user_can_create = {
    1: $e("Invité"),
    2: $e("Opérateur visu"),
    3: $e("Opérateur"),
    4: $e("Chef d'équipe"),
    5: $e("Administrateur"),
  }

  /** -------------------------- */

  static get() {
    return {
      user_type: this.user_type,
      user_can_create: this.user_can_create,
    }
  }
}
